export const statusFilter = [
  'NEW',
  'SEND',
  'PROCESSING',
  'PARTIALLY ACCEPTED',
  'ACCEPTED',
  'REJECTED',
  'DELETED',
];
